import { PageContainer } from '@/layouts/PageContainer';
import { Claims, Panels } from './ClaimsPanels';
import {
  Ageing,
  Invoices,
  KnockOff,
  Members,
  Remittances,
} from './FinanceLedger';

export type FinanceMode =
  | 'panels'
  | 'claims'
  | 'invoices'
  | 'ageing'
  | 'remittances'
  | 'knockOff'
  | 'memberVerification';

/** Finance / panel claims pages (RL-727); each matches its Admin v2 prototype page. */
export function FinanceWorkflowsPage({ mode }: { mode: FinanceMode }) {
  return (
    <PageContainer>
      {mode === 'panels' && <Panels />}
      {mode === 'claims' && <Claims />}
      {mode === 'invoices' && <Invoices />}
      {mode === 'ageing' && <Ageing />}
      {mode === 'remittances' && <Remittances />}
      {mode === 'knockOff' && <KnockOff />}
      {mode === 'memberVerification' && <Members />}
    </PageContainer>
  );
}
